import React from 'react'

interface ProcessStepsCardProps {
  steps: {
    step: number
    text: string
  }[]
}

export const ProcessStepsCard: React.FC<ProcessStepsCardProps> = ({
  steps,
}) => {
  return (
    <div className="mb-4">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">
        ¿Qué sucederá después?
      </h3>
      <div className="space-y-3">
        {steps.map(step => (
          <div key={step.step} className="flex items-start">
            <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-blue-600">
                {step.step}
              </span>
            </div>
            <p className="text-sm text-gray-600 ml-3">{step.text}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
